import { BACKEND } from "@/lib/api";
import { Folder, FilePdf } from "@phosphor-icons/react";

function flatten(node, depth = 0, acc = []) {
  acc.push({ kind: "folder", key: `f-${node.name}-${depth}-${acc.length}`, name: node.name, depth });
  Object.values(node.children || {}).forEach((c) => flatten(c, depth + 1, acc));
  (node.files || []).forEach((file) =>
    acc.push({ kind: "file", key: `p-${file.id}`, depth: depth + 1, file })
  );
  return acc;
}

export function DriveView({ tree }) {
  if (!tree) return null;
  const rows = flatten(tree);
  return (
    <div className="animate-fadein bg-white rounded-md border border-slate-200 p-5" data-testid="drive-tree">
      {rows.map((r) =>
        r.kind === "folder" ? (
          <div
            key={r.key}
            className="flex items-center gap-2 py-1 text-sm text-slate-700"
            style={{ paddingLeft: r.depth * 18 }}
          >
            <Folder size={16} weight="fill" className="text-amber-400" />
            <span className="font-medium">{r.name}</span>
          </div>
        ) : (
          <a
            key={r.key}
            href={`${BACKEND}${r.file.link}`}
            target="_blank"
            rel="noreferrer"
            data-testid={`drive-file-${r.file.id}`}
            className="flex items-center gap-2 py-1 text-xs text-slate-500 hover:text-rose-600 transition-colors"
            style={{ paddingLeft: r.depth * 18 }}
          >
            <FilePdf size={15} className="text-rose-400" />
            <span className="font-mono truncate">{r.file.nombre}</span>
          </a>
        )
      )}
    </div>
  );
}
